// extracted by mini-css-extract-plugin
export default {"form":"CreateForm_form__A7Ko5","title":"CreateForm_title__If1NW","selector":"CreateForm_selector__g3xrL","submit":"CreateForm_submit__OG0JF"};